// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmartCommandSectionTwo {
  background: #E2E6FF;
  height: auto;
  width: 100%;
}

.SmartCommandSectionTwo-Menu .ui.secondary.pointing.menu {
  height: 60px;
  justify-content: center;
  align-items: center;
  border-bottom: 3px solid #f7f7f7 !important;
  text-align: center;
}
.SmartCommandSectionTwo-Menu .ui.secondary.pointing.menu .item {
  width: auto;
  height: 60px;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #1c2640 !important;
  opacity: 1 !important;
  margin: 0 90px;
}
.SmartCommandSectionTwo-Menu .ui.secondary.pointing.menu .item .ui.header {
  font-size: 20px;
  font-weight: 500;
  font-family: "Roboto", Roboto !important;
  color: #1c2640;
  line-height: 1.86;
  height: 55px;
  padding: inherit;
}
.SmartCommandSectionTwo-Menu .ui.secondary.pointing.menu .item:hover {
  cursor: pointer;
}
.SmartCommandSectionTwo-Menu .ui.secondary.pointing.menu .item:hover .ui.header {
  color: #ec7c45;
  border-bottom: 4px solid #ec7c45;
  transition: 0.4s;
}
.SmartCommandSectionTwo-Menu .ui.secondary.pointing.menu > .item.active, .SmartCommandSectionTwo-Menu .ui.secondary.pointing.menu > .menu > .item.active {
  border-color: transparent;
}
.SmartCommandSectionTwo-Menu .ui.secondary.pointing.menu > .item.active .ui.header {
  color: #ec7c45;
  border-bottom: 4px solid #ec7c45;
}

.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper {
  padding: 100px 300px;
  background: #E2E6FF;
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 1s;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .header {
  font-family: Roboto;
  text-align: center;
  font-size: 43px;
  margin-bottom: 80px;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom {
  display: flex;
  margin-bottom: 60px;
  gap: 4%;
  align-items: center;
  height: 300px;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom .content-wrapper-left {
  width: 40%;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom .content-wrapper-left .header1 {
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #52667C;
  font-size: 0.95rem;
  font-weight: 500;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom .content-wrapper-left .header2 {
  color: #1C2640;
  font-size: 32px;
  margin-top: 5px;
  margin-bottom: 15px;
  line-height: 1.387;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom .content-wrapper-left .txt-content {
  color: #52667C;
  font-size: 18px;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom .content-wrapper-left .txt-content ul {
  padding-left: 20px;
  margin-top: -10px;
  line-height: 1.8;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom .content-wrapper-left .txt-content li {
  color: #ec7c45;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom .content-wrapper-left .txt-content span {
  color: #52667C;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom .content-wrapper-right {
  width: 60%;
  margin-top: -20px;
  text-align: right;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom .content-wrapper-right img {
  margin-left: -30px;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom .txt-center {
  text-align: center !important;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom .txt-center img {
  margin-left: 185px;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom-2 {
  margin-bottom: 60px;
  display: flex;
  gap: 4%;
  align-items: center;
  height: 300px;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom-2 .content-wrapper-right {
  width: 40%;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom-2 .content-wrapper-right .header1 {
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #52667C;
  font-size: 0.95rem;
  font-weight: 500;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom-2 .content-wrapper-right .header2 {
  color: #1C2640;
  font-size: 32px;
  line-height: 1.3;
  margin-top: 5px;
  margin-bottom: 15px;
  line-height: 1.387;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom-2 .content-wrapper-right .txt-content {
  color: #52667C;
  font-size: 18px;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom-2 .content-wrapper-right .txt-content ul {
  padding-left: 20px;
  margin-top: -10px;
  line-height: 1.8;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom-2 .content-wrapper-right .txt-content li {
  color: #ec7c45;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom-2 .content-wrapper-right .txt-content span {
  color: #52667C;
}
.SmartCommandSectionTwo .SmartCommandSectionTwo-content-wrapper .section-custom-2 .content-wrapper-left {
  width: 60%;
  margin-top: -20px;
  margin-left: -45px;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SmartCommand/SectionTwo/sectionTwo.scss"],"names":[],"mappings":"AAAA;EACC,mBAAA;EACG,YAAA;EACA,WAAA;AACJ;;AAGC;EACC,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,2CAAA;EACG,kBAAA;AAAL;AAGC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AADF;AAEE;EACC,eAAA;EACA,gBAAA;EACA,wCAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AAAH;AAIC;EACC,eAAA;AAFF;AAGE;EACC,cAAA;EACA,gCAAA;EACA,gBAAA;AADH;AAKC;EACC,yBAAA;AAHF;AAOE;EACC,cAAA;EACA,gCAAA;AALH;;AAWC;EACC,oBAAA;EACG,mBAAA;EACA,UAAA;EACH,6BAAA;EACA,4BAAA;EACA,kCAAA;EACA,sBAAA;AARF;AASE;EACC,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAPH;AAUE;EACC,aAAA;EACA,mBAAA;EACA,OAAA;EACA,mBAAA;EACA,aAAA;AARH;AASG;EACC,UAAA;AAPJ;AAQI;EACC,mBAAA;EACG,yBAAA;EACA,cAAA;EACA,kBAAA;EACH,gBAAA;AANL;AAQI;EACC,cAAA;EAGA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AARL;AAUI;EACC,cAAA;EACA,eAAA;AARL;AASK;EACC,kBAAA;EACA,iBAAA;EACA,gBAAA;AAPN;AASK;EAAK,cAAA;AANV;AAOK;EAAO,cAAA;AAJZ;AAOG;EACC,UAAA;EACA,iBAAA;EACA,iBAAA;AALJ;AAMI;EACC,kBAAA;AAJL;AAOG;EACC,6BAAA;AALJ;AAMI;EACC,kBAAA;AAJL;AAUE;EACC,mBAAA;EACA,aAAA;EACA,OAAA;EACA,mBAAA;EACA,aAAA;AARH;AASG;EACC,UAAA;AAPJ;AASI;EACC,mBAAA;EACG,yBAAA;EACA,cAAA;EACA,kBAAA;EACH,gBAAA;AAPL;AASI;EACC,cAAA;EACA,eAAA;EAEA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AARL;AAUI;EACC,cAAA;EACA,eAAA;AARL;AASK;EACC,kBAAA;EACA,iBAAA;EACA,gBAAA;AAPN;AASK;EAAK,cAAA;AANV;AAOK;EAAO,cAAA;AAJZ;AAOG;EACC,UAAA;EACA,iBAAA;EACA,kBAAA;AALJ;;AAYA;EACC;IACC,UAAA;EATA;EAWD;IACC,UAAA;EATA;AACF","sourcesContent":[".SmartCommandSectionTwo {\n\tbackground: #E2E6FF;\n    height: auto;\n    width: 100%;\n}\n\n.SmartCommandSectionTwo-Menu {\n\t.ui.secondary.pointing.menu {\n\t\theight: 60px;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder-bottom: 3px solid #f7f7f7 !important;\n\t    text-align: center;\n\t}\n\n\t.ui.secondary.pointing.menu .item {\n\t\twidth: auto;\n\t\theight: 60px;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\ttext-align: center;\n\t\tcolor: #1c2640 !important;\n\t\topacity: 1 !important;\n\t\tmargin: 0 90px;\n\t\t.ui.header {\n\t\t\tfont-size: 20px;\n\t\t\tfont-weight: 500;\n\t\t\tfont-family: 'Roboto', Roboto !important;\n\t\t\tcolor: #1c2640;\n\t\t\tline-height: 1.86;\n\t\t\theight: 55px;\n\t\t\tpadding: inherit;\n\t\t}\n\t}\n\n\t.ui.secondary.pointing.menu .item:hover {\n\t\tcursor: pointer;\n\t\t.ui.header {\n\t\t\tcolor: #ec7c45;\n\t\t\tborder-bottom: 4px solid #ec7c45;\n\t\t\ttransition: 0.4s;\n\t\t}\n\t}\n\n\t.ui.secondary.pointing.menu>.item.active, .ui.secondary.pointing.menu>.menu>.item.active {\n\t\tborder-color: transparent;\n\t}\n\n\t.ui.secondary.pointing.menu >.item.active{\n\t\t.ui.header {\n\t\t\tcolor: #ec7c45;\n\t\t\tborder-bottom: 4px solid #ec7c45;\n\t\t}\n\t}\n}\n\n.SmartCommandSectionTwo{\n\t.SmartCommandSectionTwo-content-wrapper {\n\t\tpadding: 100px 300px;\n\t    background: #E2E6FF;\n\t    opacity: 1;\n\t\tanimation-name: fadeInOpacity;\n\t\tanimation-iteration-count: 1;\n\t\tanimation-timing-function: ease-in;\n\t\tanimation-duration: 1s;\n\t\t.header {\n\t\t\tfont-family: Roboto;\n\t\t\ttext-align: center;\n\t\t\tfont-size: 43px;\n\t\t\tmargin-bottom: 80px;\n\t\t}\n\n\t\t.section-custom {\n\t\t\tdisplay: flex;\n\t\t\tmargin-bottom: 60px;\n\t\t\tgap: 4%;\n\t\t\talign-items: center;\n\t\t\theight: 300px;\n\t\t\t.content-wrapper-left {\n\t\t\t\twidth: 40%;\n\t\t\t\t.header1 {\n\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t    text-transform: uppercase;\n\t\t\t\t    color: #52667C;\n\t\t\t\t    font-size: .95rem;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t}\n\t\t\t\t.header2 {\n\t\t\t\t\tcolor: #1C2640;\n\t\t\t\t\t// font-size: 30px;\n\t\t\t\t\t// font-weight: bold;\n\t\t\t\t\tfont-size: 32px;\n\t\t\t\t\tmargin-top: 5px;\n\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t\tline-height: 1.387;\n\t\t\t\t}\n\t\t\t\t.txt-content {\n\t\t\t\t\tcolor: #52667C;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tul {\n\t\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\t\tmargin-top: -10px;\n\t\t\t\t\t\tline-height: 1.8;\n\t\t\t\t\t}\n\t\t\t\t\tli { color: #ec7c45; }\n\t\t\t\t\tspan { color: #52667C; }\n\t\t\t\t}\n\t\t\t}\n\t\t\t.content-wrapper-right {\n\t\t\t\twidth: 60%;\n\t\t\t\tmargin-top: -20px;\n\t\t\t\ttext-align: right;\n\t\t\t\timg {\n\t\t\t\t\tmargin-left: -30px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.txt-center{\n\t\t\t\ttext-align: center !important;\n\t\t\t\timg{\n\t\t\t\t\tmargin-left: 185px;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t}\n\n\t\t.section-custom-2 {\n\t\t\tmargin-bottom: 60px;\n\t\t\tdisplay: flex;\n\t\t\tgap: 4%;\n\t\t\talign-items: center;\n\t\t\theight: 300px;\n\t\t\t.content-wrapper-right {\n\t\t\t\twidth: 40%;\n\t\t\t\t// margin-left: -150px;\n\t\t\t\t.header1 {\n\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t    text-transform: uppercase;\n\t\t\t\t    color: #52667C;\n\t\t\t\t    font-size: .95rem;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t}\n\t\t\t\t.header2 {\n\t\t\t\t\tcolor: #1C2640;\n\t\t\t\t\tfont-size: 32px;\n\t\t\t\t\t// font-weight: bold;\n\t\t\t\t\tline-height: 1.3;\n\t\t\t\t\tmargin-top: 5px;\n\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t\tline-height: 1.387;\n\t\t\t\t}\n\t\t\t\t.txt-content {\n\t\t\t\t\tcolor: #52667C;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tul {\n\t\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\t\tmargin-top: -10px;\n\t\t\t\t\t\tline-height: 1.8;\n\t\t\t\t\t}\n\t\t\t\t\tli { color: #ec7c45; }\n\t\t\t\t\tspan { color: #52667C; }\n\t\t\t\t}\n\t\t\t}\n\t\t\t.content-wrapper-left {\n\t\t\t\twidth: 60%;\n\t\t\t\tmargin-top: -20px;\n\t\t\t\tmargin-left: -45px;\n\t\t\t}\n\t\t}\n\t}\n\n}\n\n@keyframes fadeInOpacity {\n\t0% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
